<i2a-page-content [hasPadding]="true" [headerStyle]="headerStyle">
    <ng-container navbar>
        <i2a-nav-bar></i2a-nav-bar>
    </ng-container>
    <ng-container content-body>
        <i2a-user-list></i2a-user-list>
        <router-outlet></router-outlet>
    </ng-container>
</i2a-page-content>